module.exports = __webpack_public_path__ + "img/under_maintenance.b64d6347.jpg";